<template>
    <div>
        <buttonlist @help="help" @add="add" @search="search" @reflash="reflash" @exps="exps" @save="save" @del="del"
                    ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left1" ref="left1">
                <el-table
                        :data="dataSet"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        stripe
                        size="mini"
                        :height="tableHeight"
                        @row-click="editInfo"
                        header-row-class-name="headerclass"
                        style="width: 100%; margin-top:0px"
                        ref="singleTable"
                >
                    <el-table-column type="selection" v-if="false"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Budget_Year" :label="$t('getapi[2484]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Budget_Month" :label="$t('getapi[6345]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Budget_department"
                                     :label="$t('getapi[1833]')"></el-table-column>
                    <el-table-column prop="Budget_Amount" :label="$t('getapi[8484]')" v-if="visAmount" align="right" width="120">
                        <template slot-scope="scope">
                            {{scope.row.Budget_Amount | thousandthpuramount}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="Actual_Amount" :label="$t('getapi[8477]')" v-if="visAmount" align="right" width="120">
                        <template slot-scope="scope">
                            {{scope.row.Actual_Amount | thousandthpuramount}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="Remain_Amount" :label="$t('getapi[8441]')" v-if="visAmount" align="right" width="120">
                        <template slot-scope="scope">
                            {{scope.row.Remain_Amount | thousandthpuramount}}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="currency_code" :label="$t('getapi[8339]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[410]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="create_time" :label="$t('getapi[135]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="update_person" :label="$t('getapi[733]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="update_time"
                                     :label="$t('getapi[1210]')"></el-table-column>
                </el-table>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid1" ref="mid1">
                <div style="width:270px">
                    <table>
                        <tr>
                            <td style="width:60px">{{ $t('getapi[2484]') }}</td>
                            <td style="width:210px;">
                                <el-input type="text" size="number" v-model="dataDetail.Budget_Year" :readonly="addoredit != 0" :class="{'readO':addoredit != 0}"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td style="width:60px">{{ '月' }}</td>
                            <td style="width:210px;">
                                <el-select filterable v-model="dataDetail.Budget_Month" size="mini" :disabled="addoredit != 0">
                                    <el-option v-for="item in arrmonth" :key="item.Name" :label="item.Name"
                                               :value="item.Code"></el-option>
                                </el-select>
                            </td>
                        </tr>
                        <tr>
                            <td style="width:60px">{{ $t('getapi[1833]') }}</td>
                            <td style="width:150px;">
                                <routejump :urlNo="28" v-show="addoredit == 0">
                                <el-input  type="text" v-model="dataDetail.Budget_Department"
                                           readonly
                                           size="mini"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectpartment()"></i>
                                </el-input>
                                </routejump>
                                <el-input type="text" size="number" v-model="dataDetail.Budget_Department" :readonly="true" class="readO" v-show="addoredit != 0"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td style="width:60px">{{ $t('getapi[8484]')}}</td>
                            <td style="width:150px;">
                                <el-input type="text" size="number" v-model="dataDetail.Budget_Amount"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td style="width:60px">{{ $t('getapi[8477]') }}</td>
                            <td style="width:150px;">
                                <el-input type="text" size="number" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td style="width:60px">{{ $t('getapi[8441]') }}</td>
                            <td style="width:150px;">
                                <el-input type="text" size="number" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td style="width:60px">{{ $t('getapi[8339]') }}</td>
                            <td style="width:150px;">
                                <routejump :urlNo="24" v-show="addoredit == 0">
                                <el-input  type="text" v-model="dataDetail.Currency_Code"
                                           readonly
                                           size="mini"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectcurrency()"></i>
                                </el-input>
                                <el-input type="text" size="number" v-model="dataDetail.Currency_Code" :readonly="true" class="readO"  v-show="addoredit != 0"></el-input>
                                {{currencyname}}
                                </routejump>
                            </td>
                        </tr>
                        <tr>
                            <td style="width:60px">{{ $t('getapi[410]') }}</td>
                            <td style="width:150px;">
                                <el-input type="text" size="mini" v-model="dataDetail.Create_Person" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td style="width:60px">{{ $t('getapi[135]') }}</td>
                            <td style="width:150px;">
                                <el-input type="text" size="mini" v-model="dataDetail.Create_Time" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td style="width:60px">{{ $t('getapi[733]') }}</td>
                            <td style="width:150px;">
                                <el-input type="text" size="mini" v-model="dataDetail.Update_Person" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td style="width:60px">{{ $t('getapi[1210]') }}</td>
                            <td style="width:150px;">
                                <el-input type="text" size="mini" v-model="dataDetail.Update_Time" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                    </table>
                </div>
            </li>
        </ul>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="PurMroBudgetViewInfo" ref="ser" @getser="serclick"></serce>
        <!--选择部门-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Pur/MRO/GetDepartmentInfoPopupList'" @callback="getpartment" ref="partment"></selector>
        <!--选择币种-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Pur/MRO/GetCurrencyInfoPopupList'" @callback="getcurrency" ref="currency"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: 'purmrobudge',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                visPrintType:false,//打印选择弹框
                printflag:'0',
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                dataSet: [], // 主表数据
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('purmrobudge'), // 当前页数据量
                total: 0, // 数据总量
                SelectIndex: 0, //当前页面
                dataSet1: [], // 主表数据
                loading: false, // 主表加载状态
                dataDetail:{
                },
                currencyname:'', //币种中文名称
                oldDataDetail: '',
                addoredit: 0,
                //金额是否显示
                visAmount:false,
                arrmonth: [{
                    Name: 1,
                    Code: 1
                },{
                    Name: 2,
                    Code: 2
                },{
                    Name: 3,
                    Code: 3
                },{
                    Name: 4,
                    Code: 4
                },{
                    Name: 5,
                    Code: 5
                },{
                    Name: 6,
                    Code: 6
                },{
                    Name: 7,
                    Code: 7
                },{
                    Name: 8,
                    Code: 8
                },{
                    Name: 9,
                    Code: 9
                },{
                    Name: 10,
                    Code: 10
                },{
                    Name: 11,
                    Code: 11
                },{
                    Name: 12,
                    Code: 12
                }],
                oldrow: '',
                scrollTop:0,
            };
        },
        mounted: function () {
            let that = this;
            that.$processdata.pushModelCache('purmrobudge', that)
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            that.$limits.dragControllerDiv1();
            that.oldDataDetail = JSON.stringify(that.dataDetail)
            that.confirmAdd()
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6550]"),this.$t("getapi[16]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                if (that.$limits.authority('plv4', 115, 1) == 0) {
                    console.log("ceshi 1");
                     that.visAmount=false;
                }
                 else{
                     console.log("ceshi 2");
                    that.visAmount=true;
                }               

                //管理界面
                if (that.$limits.authority('plv2', 325, 1) == 1) {
                    //只读权
                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                }
                else if (that.$limits.authority('plv2', 325, 1) == 2) {
                    if (that.$limits.authority('plv3', 325,1) == 0) {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    //操作权
                    if (that.$limits.authority('plv3', 325,1) == 1) {
                        //编辑级
                        that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');

                    }
                    if (that.$limits.authority('plv3', 325, 1) == 2) {
                        //删除级
                        that.$refs.SetBtn.SetButtonEnable('create,save,del,search,refresh,export');
                    }
                }
                else{
                    that.$refs.SetBtn.SetButtonEnable('search,refresh');
                     if (that.$limits.authority('plv2', 61,1)>0) {
                        if (that.total > 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        } 
                     }
                }
                
                that.btnauthority();
            },
            btnauthority() {
                let that = this
            },
            leftt(e) {
                var left = document.getElementsByClassName('left1');
                var mid = document.getElementsByClassName('mid1');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('purmrobudge',val)
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            selectInfo(tab, event) {
                let that = this;
                that.SelectIndex = tab.name;
                that.getView();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'PurMroBudgetViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndex,
                    Param: datac
                };
                that.$http.urlpost('/Pur/MRO/MROViewDataList', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    }
                });
            },
            // 根据ID获取详情数据
            editInfo(row) {
                let that = this;
                if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                    that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.oldrow = row
                            let parm = {
                                Budget_Year: row.Budget_Year,
                                Budget_Month: row.Budget_Month,
                                Budget_Department: row.Budget_department
                            }
                            that.code = parm
                            that.getDetail(parm)
                        })
                        .catch(() => {
                            that.$refs.singleTable.setCurrentRow(that.oldrow);
                        });
                } else {
                    that.oldrow = row
                    let parm = {
                        Budget_Year: row.Budget_Year,
                        Budget_Month: row.Budget_Month,
                        Budget_Department: row.Budget_department
                    }
                    that.code = parm
                    that.getDetail(parm)
                }
            },
            // 新增
            add() {
                let that = this;
                if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.confirmAdd()
                        });
                } else {
                    that.confirmAdd()
                }
            },
            confirmAdd(){
                let that = this;
                that.addoredit = 0
                that.code = {
                    Budget_Year: '',
                    Budget_Month: '',
                    Budget_Department: ''
                }
                that.dataDetail = {
                    isadd: 1,
                    Budget_Year: '',
                    Budget_Month: '',
                    Budget_Department: "",
                    Budget_Amount: '',
                    Currency_Code: "CNY",
                    Create_Person: "",
                    Create_Time: "",
                    Update_Person: "",
                    Update_Time: ""
                }
                that.currencyname = '人名币'
                that.oldDataDetail = JSON.stringify(that.dataDetail)
                that.authority();
            },
            // 刷新
            reflash() {
                let that = this;
                if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.getView();
                            if(that.addoredit == 0){
                                that.confirmAdd()
                            } else {
                                that.getDetail(that.code)
                            }
                        });
                } else {
                    if(that.addoredit == 0){
                        that.getView();
                        that.confirmAdd()
                    } else {
                        that.getView();
                        that.getDetail(that.code)
                    }
                }
            },
            // 导出
            exps() {
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac,
                    LangType: that.$processdata.getLang(),
                    fromname: that.$t('getapi[11149]')
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost('/Pur/MRO/MROViewExportToExecl', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            // 保存
            save() {
                let that = this;
                if(that.dataDetail.Budget_Year == '' || that.dataDetail.Budget_Month == '' || that.dataDetail.Budget_Department == ''){
                    that.$message.warning(that.$t('getapi[8714]'))//'年，月，部门不能为空！'
                    return
                }
                let parm = that.dataDetail
                parm.LangType = that.$processdata.getLang()
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                that.$http.urlpost('/Pur/MRO/MROSaveData', parm, function(res) {
                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.code = {
                            Budget_Year: that.dataDetail.Budget_Year,
                            Budget_Month: that.dataDetail.Budget_Month,
                            Budget_Department: that.dataDetail.Budget_Department
                        }
                        that.getDetail(that.code)
                    }
                });
            },
            getDetail(code) {
                let that = this;
                that.addoredit = 1
                let parm = code
                that.$http.urlpost('/Pur/MRO/GetMROBillInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                        that.authority();
                        that.btnauthority()
                    }
                });
            },
            del(){
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            Budget_Year: that.dataDetail.Budget_Year,
                            Budget_Month: that.dataDetail.Budget_Month,
                            Budget_Department: that.dataDetail.Budget_Department
                        }
                        that.$refs.SetBtn.SetOneBtnEnable('del',false);
                        that.$http.urlpost('/Pur/MRO/DeleteMRO', parm, function (res) {
                            that.$refs.SetBtn.SetOneBtnEnable('del',true);
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getView()
                                that.confirmAdd()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            selectcurrency(){
                let that = this;
                that.$refs.currency.clearInput(true);
            },
            getcurrency(data){
                let that = this
                console.log(data)
                that.dataDetail.Currency_Code = data.code
                that.currencyname = data.name
            },
            selectpartment(){
                let that = this;
                that.$refs.partment.clearInput(true);
            },
            getpartment(data){
                let that = this
                console.log(data)
                that.dataDetail.Budget_Department = data.name
            },
            checkDataChange(){
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 325,1) < 1){
                    return false
                }
                let flag =  that.oldDataDetail != JSON.stringify(that.dataDetail)
                return flag
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    /deep/ .green {
        background: #c8ffbb;
    }
    /deep/ .red {
        color: #ff7879;
    }

    /deep/.el-table .hidden-row {
        display: none;
    }
</style>
